import { SK_userSession } from '../../data/config';
import { getEnvironment } from '../../enviroments';
import { FilePurpose } from '../../libs/interfaces/filePurpose';
import { FileUploadParams } from '../../libs/interfaces/fileUpload';
import { UserSessionType } from '../../store/slices/UserSession/userSession';
import { parseJsonFromLocal } from '../../utils/helperFunction/jsonHandler';
import { getPresignedUrl } from './getPresignedUrl';
import { saveFileToBucket } from './saveFileToBucket';
import { sendFileInfoToBackend } from './sendFileInfoToBackend';

export const presignAndSaveToBucket = async ({
  file,
  authToken,
  file_purpose,
}: {
  file: File;
  authToken: string;
  file_purpose: FilePurpose;
}) => {
  const response: { url: string | null; type: string | null } = {
    url: null,
    type: null,
  };

  const presignedUrlRes = await getPresignedUrl({
    authToken,
    file_purpose,
    file_type: file.type,
  });
  const saved = await saveFileToBucket({
    file,
    presignedUrl: presignedUrlRes.details?.url as string,
  });

  if (saved) {
    const env = getEnvironment();
    response.url = `${env.BUCKET_URL}/${presignedUrlRes.details?.fileName}`;
    const file_Name_obj = (presignedUrlRes.details?.fileName as string).split(
      '.'
    );
    response.type = `.${file_Name_obj.pop()}`;
  }
  return response;
};

const uploadFile = async ({
  file_purpose,
  file,
  requires_image,
}: FileUploadParams) => {
  try {
    if (!file) throw new Error('No file provided for upload');
    const authToken =
      parseJsonFromLocal<UserSessionType>(SK_userSession)?.signedAccessToken ||
      '';

    const { url: bucketRef, type: bucketRefType } =
      await presignAndSaveToBucket({
        file,
        file_purpose,
        authToken,
      });

    if (!bucketRef || !bucketRefType) throw new Error('failed to save file');

    const res = await sendFileInfoToBackend({
      authToken,
      file_url: bucketRef,
      file_purpose,
      file_type: bucketRefType,
      requires_image,
    });

    return {
      file_id: res.details?.file_id,
      role_id: res.details?.role_id,
      url: bucketRef,
      type: bucketRefType,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default uploadFile;
